import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-route-plan-view',
    templateUrl: './route-plan-view.component.html',
    styleUrls: ['./route-plan-view.component.scss'],
    standalone: false
})
export class RoutePlanViewComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
